export const IconFacebook = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_65_18802)">
        <path d="M11.6667 16.7188H15.8333V5.05216H4.16667V16.7188H10V12.5522H8.33333V10.8855H10V9.50716C10 8.393 10.1167 7.98883 10.3333 7.58133C10.5468 7.17815 10.8766 6.84857 11.28 6.6355C11.5983 6.46466 11.9942 6.36216 12.6858 6.318C12.96 6.3005 13.315 6.32216 13.7508 6.38466V7.968H13.3333C12.5692 7.968 12.2533 8.00383 12.065 8.10466C11.9526 8.16246 11.8611 8.25395 11.8033 8.36633C11.7033 8.55466 11.6667 8.74133 11.6667 9.50633V10.8855H13.75L13.3333 12.5522H11.6667V16.7188ZM3.33333 3.3855H16.6667C16.8877 3.3855 17.0996 3.4733 17.2559 3.62958C17.4122 3.78586 17.5 3.99782 17.5 4.21883V17.5522C17.5 17.7732 17.4122 17.9851 17.2559 18.1414C17.0996 18.2977 16.8877 18.3855 16.6667 18.3855H3.33333C3.11232 18.3855 2.90036 18.2977 2.74408 18.1414C2.5878 17.9851 2.5 17.7732 2.5 17.5522V4.21883C2.5 3.99782 2.5878 3.78586 2.74408 3.62958C2.90036 3.4733 3.11232 3.3855 3.33333 3.3855Z" fill="#979797"/>
      </g>
      <defs>
        <clipPath id="clip0_65_18802">
          <rect width="20" height="20" fill="white" transform="translate(0 0.885498)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
